import styled, { css } from "styled-components";

const iconOverrides = css`
  min-width: ${p => p.theme.Button.height}px;
  padding: 0;
  width: ${p => p.theme.Button.height}px;
`;

export const Button = styled.button.attrs(props => ({
  type: props.type || "button",
}))`
  background-color: ${p => p.theme.Button.backgroundColor};
  border-radius: ${p => p.theme.Button.borderRadius || 0};
  border: ${p => p.theme.Button.border};
  color: ${p => p.theme.Button.color};
  cursor: pointer;
  font-family: ${p => p.theme.fontFamily};
  font-size: 13px;
  font-weight: 400;
  min-width: 100px;
  height: ${p => p.theme.Button.height};
  outline: 0;
  padding: 0 1.5em;
  text-align: center;
  text-shadow: none;
  user-select: none;
  vertical-align: middle;
  &:disabled,
  &[disabled] {
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
  }
  &:hover {
    background-color: ${p => p.theme.Button.hover.backgroundColor};
    border-color: ${p => p.theme.Button.hover.backgroundColor};
    color: ${p => p.theme.Button.hover.color};
  }

  a {
    text-decoration: none;
  }

  i,
  img,
  svg {
    vertical-align: middle;
  }
`;
export const IconButton = styled(Button)`
  ${iconOverrides};
`;

export const ActionButton = styled(Button)`
  background: ${p => p.theme.ActionButton.background};
  color: ${p => p.theme.ActionButton.color};
  border: none;

  :hover {
    background: ${p => p.theme.ActionButton.hover.background};
  }
`;

export const TransparentButton = styled(Button)`
  background-color: transparent;
  border-color: transparent;
  :hover {
    background-color: ${p => p.theme.TransparentButton.hover.backgroundColor};
    border-color: ${p => p.theme.TransparentButton.hover.backgroundColor};
  }
`;
export const TransparentIconButton = styled(TransparentButton)`
  ${iconOverrides};
`;

export const WarningButton = styled(Button)`
  background-color: ${p => p.theme.WarningButton.background};
  border-color: ${p => p.theme.WarningButton.background};
  color: ${p => p.theme.empty};
  :hover {
    background-color: ${p => p.theme.WarningButton.hover.background};
    border-color: ${p => p.theme.WarningButton.hover.background};
  }
`;

export const PrimaryButton = styled(Button)`
  background-color: ${p => p.theme.PrimaryButton.backgroundColor};
  color: ${p => p.theme.PrimaryButton.color};
`;
export const PrimaryIconButton = styled(PrimaryButton)`
  ${iconOverrides};
`;

export const DangerButton = styled(Button)`
  background-color: ${p => p.theme.DangerButton.backgroundColor};
  border-color: ${p => p.theme.DangerButton.borderColor};
  color: ${p => p.theme.DangerButton.color};
  :hover {
    background-color: ${p => p.theme.DangerButton.hover.backgroundColor};
    border-color: ${p => p.theme.DangerButton.hover.backgroundColor};
    color: ${p => p.theme.DangerButton.hover.color};
  }
`;
export const DangerIconButton = styled(DangerButton)`
  ${iconOverrides};
`;

export const AltPrimaryButton = styled(Button)`
  background-color: ${p => p.theme.AltPrimaryButton.backgroundColor};
  border-color: ${p => p.theme.AltPrimaryButton.borderColor};
  color: ${p => p.theme.AltPrimaryButton.color};
  :hover {
    background-color: ${p => p.theme.AltPrimaryButton.hover.backgroundColor};
    border-color: ${p => p.theme.AltPrimaryButton.hover.backgroundColor};
    color: ${p => p.theme.AltPrimaryButton.hover.color};
  }
`;

export const RoundButton = styled(Button)`
  box-sizing: border-box;
  height: 25px;
  min-width: 130px;
  border: ${p => p.theme.border};
  border-radius: 100px;
  background-color: ${p => p.theme.RoundButton.backgroundColor};
  color: ${p => p.theme.RoundButton.color};
  font-size: ${p => p.theme.TableHeader.fontSize};
  font-weight: ${p => p.theme.TableHeader.fontWeight};
  text-transform: uppercase;
  :hover {
    border-color: ${p => p.theme.RoundButton.borderColor};
    background-color: ${p => p.theme.RoundButton.backgroundColor};
    color: ${p => p.theme.RoundButton.color};
  }
`;

export const ButtonGroup = styled.div`
  padding-top: 20px;
  text-align: right;
  button {
    margin-left: 10px;
  }
  button:first-child {
    margin-left: 0;
  }
`;
